import { text_mod_85 } from "../text/Text.js";

export const module85 = {
  title: "Будова тексту",
  questions: [
    {
      id: 1,
      onlyText: true,
      text: text_mod_85,
    },
  ],
};
